import FormWizard from './components/form-wizard/form-wizard.component';
import { FormEngineProps } from './form-engine.model';

// Decision making component
// This component will be responsible for deciding which UI to render
// based on the current state of the application
export const FormEngineController = (props: FormEngineProps) => {
  return <FormWizard {...props} />;
};
